import Vue from 'vue'
import mixins from '@/common/js/mixin'
mixins.forEach(mixin => Vue.mixin(mixin))

// Vue.config.optionMergeStrategies.data = function (toVal, fromVal) {
//   // 返回合并后的值
//   console.log(toVal, fromVal)
//   return Object.assign({}, toVal, fromVal)
// }
